import moment from "moment";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { useMount } from "react-use";
import { useRecoilState } from "recoil";
import { getQuizResult } from "../../api";
import Quiz from "../../components/quiz/Quiz";
import { quizInfoTitle } from "../../states/atoms/quizState";
import { useLocationQuery } from "../../util/common";

const QuizResultPage = () => {
  const query = useLocationQuery();
  const { lecture_id, student_id, parent_id, quiz_id } = query;
  const queryClient = useQueryClient();
  const [title, setTitle] = useRecoilState(quizInfoTitle);
  const [quiz, setQuiz] = useState(null);

  const getListQuery = async () => {
    const result = await queryClient.fetchQuery(["quiz/result"], {
      queryFn: () =>
        getQuizResult({ lecture_id, student_id, parent_id, quiz_id }),
    });
    if (result.result) {
      setTitle(result.data.title);
      setQuiz(result.data.quiz);
    }
  };

  useMount(() => {
    getListQuery();
  });

  return (
    <div className="container mx-auto lg:my-8 lg:max-w-screen-lg">
      <div className="lg:rounded-t-3xl bg-cyan-500 px-6 py-4 md:px-10 md:py-8">
        <h1 className="break-keep text-3xl md:text-5xl leading-tight text-white font-bold">
          {`${title} 결과 확인`}
        </h1>
        {quiz && (
          <div className="flex flex-col mt-4 md:mt-8 cursor-default">
            <div className="flex flex-row flex-wrap gap-2">
              {[
                {
                  key: "quiz_response_date",
                  label: "퀴즈 응답 날짜",
                  value: moment(quiz.date).format("LLL"),
                },
                {
                  key: "quiz_spent_time",
                  label: "퀴즈 풀이 시간",
                  value: quiz.time,
                },
                {
                  key: "quiz_total_no",
                  label: "총 문제 수",
                  value: quiz.results.length,
                },
                {
                  key: "quiz_correct_no",
                  label: "맞춘 문제 수",
                  value: quiz.results.filter(({ result }) => result).length,
                },
                { key: "quiz_score", label: "점수", value: quiz.score },
              ].map(({ key, label, value }) => (
                <div
                  key={key}
                  className="stat bg-zinc-100 rounded-md p-2 md:p-4 flex-[33%]"
                >
                  <div className="stat-value text-cyan-500 text-xl md:text-2xl">
                    {value}
                  </div>
                  <div className="stat-desc opacity-100">{label}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <hr />
      <div className="md:rounded-b-3xl border-t border-zinc-200 bg-white md:p-8 shadow flex flex-col gap-6">
        {quiz &&
          quiz.results.map(({ a, q, result, type }, i) => {
            let option = false;
            let options = false;
            let answers = null;
            let response = null;
            if (type === "text") {
              option = true;
              answers = a.value.split(", ");
              response = a.student;
            } else {
              options = a;
              answers = a.reduce(
                (acc, { answer, content }) =>
                  answer ? [...acc, content] : acc,
                []
              );
              response = a.reduce(
                (acc, { response, content }) =>
                  response ? [...acc, content] : acc,
                []
              );
            }
            return (
              <Quiz
                {...{
                  q,
                  type,
                  n: i + 1,
                  readOnly: true,
                  option,
                  options,
                  answers,
                  response,
                  result,
                }}
              />
            );
          })}
      </div>
    </div>
  );
};

export default QuizResultPage;
